import { render, staticRenderFns } from "./CaseShows.vue?vue&type=template&id=3d0c2d6d&scoped=true"
import script from "./CaseShows.vue?vue&type=script&lang=js"
export * from "./CaseShows.vue?vue&type=script&lang=js"
import style0 from "./CaseShows.vue?vue&type=style&index=0&id=3d0c2d6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c2d6d",
  null
  
)

export default component.exports